import * as React from 'react';
import { AppSettingContext, AppSettingContextData } from '@contexts/appSetting/AppSettingContext';

export type WithAppSetting<A> = {
    appSetting: AppSettingContextData;
} & A;

/**
 * provide app context via AppContext
 * @param Component
 */
export function withAppSetting<TProps>(Component: React.FC<TProps>): React.FC<WithAppSetting<TProps>> {
    const ComponentWithAppSetting: React.FC<WithAppSetting<TProps>> = props => (
        <AppSettingContext.Provider value={props.appSetting}>
            <Component {...props} />
        </AppSettingContext.Provider>
    );

    ComponentWithAppSetting.displayName = `${Component.displayName || 'Component'}WithAppSetting`;

    return ComponentWithAppSetting;
}
